var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/master/AssessmentEnum';
import ApiService from '@/core/services/ApiService';
import { ElMessage } from 'element-plus';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
import { Pagination } from '@/core/enums/Pagination';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/assessments`,
    binding: `${API_URL}/api/databinding`
};
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
const BROWSER_IS_OFFLINE = !navigator.onLine;
let AssessmentModule = class AssessmentModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.assessmentList = [];
        this.scheduleList = [];
        this.bindingList = [];
        this.loading = false;
        this.modalLoading = false;
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1,
            loading: false
        };
        this.filter = {
            userType: '',
            stage: '',
            status: '',
            date: '',
            schemeId: '',
            code: ''
        };
        this.scheduleFilter = {
            date: null,
            schemeId: null,
            testPlaceId: null,
            asesiName: null,
            assessorName: null
        };
        this.orderBy = null;
    }
    // *GETTERS
    get getAssessmentList() {
        return this.assessmentList;
    }
    get getAssessmentScheduleList() {
        return this.scheduleList;
    }
    get getAssessmentFormBindingList() {
        const newData = this.bindingList.reduce((acc, curr) => {
            const existingObjIndex = acc.findIndex((obj) => {
                return obj.formCode === curr.formCode;
            });
            if (existingObjIndex !== -1) {
                acc[existingObjIndex].formTitle += ` & ${curr.formTitle}`;
            }
            else {
                acc.push(curr);
            }
            return acc;
        }, []);
        return newData;
    }
    get getAssessmentListLoading() {
        return this.loading;
    }
    get getAssessmentModalLoading() {
        return this.modalLoading;
    }
    get getAssessmentListFilter() {
        return this.filter;
    }
    get getAssessmentListPagination() {
        return this.pagination;
    }
    get getAssessmentNonNullFilter() {
        return Object.fromEntries(Object.entries(this.scheduleFilter).filter(([, value]) => {
            return value !== null;
        }));
    }
    // *MUTATIONS
    [_a = Mutations.SET_ASSESSMENT_LIST](data) {
        this.assessmentList = data;
    }
    [_b = Mutations.SET_SCHEDULE_LIST](data) {
        this.scheduleList = data;
    }
    [_c = Mutations.SET_FORM_BINDING_LIST](data) {
        this.bindingList = data;
    }
    [_d = Mutations.SET_ASSESSMENT_LIST_LOADING](data) {
        this.loading = data;
    }
    [_e = Mutations.SET_ASSESSMENT_LIST_MODAL_LOADING](data) {
        this.modalLoading = data;
    }
    [_f = Mutations.SET_ASSESSMENT_LIST_PAGINATION_LOADING](data) {
        this.pagination.loading = data;
    }
    [_g = Mutations.SET_ASSESSMENT_SCHEDULE_FILTER](data) {
        this.scheduleFilter = Object.assign(Object.assign(Object.assign({}, this.scheduleFilter), data), ((data === null || data === void 0 ? void 0 : data.date) && {
            date: data.date.toISOString()
        }));
    }
    [_h = Mutations.CLEAR_FILTER]() {
        // eslint-disable-next-line arrow-body-style
        Object.keys(this.scheduleFilter).forEach((key) => {
            return (this.scheduleFilter[key] = null);
        });
    }
    [_j = Mutations.SET_ASSESSMENT_LIST_FILTER](data) {
        this.filter = Object.assign(Object.assign({}, this.filter), data);
    }
    [_k = Mutations.RESET_ASSESSMENT_LIST_FILTER]() {
        this.filter = {
            userType: '',
            stage: '',
            status: '',
            date: '',
            schemeId: '',
            code: ''
        };
    }
    [_l = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    [_m = Mutations.SET_ASSESSMENT_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize),
            loading: false
        };
    }
    // *start: ACTION
    [_o = Actions.GET_PURPOSE_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE,
            pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/purposes?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Assessment Purpose list.'
                });
                reject(error);
            });
        });
    }
    [_p = Actions.GET_LIST](payload) {
        var _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID && !BROWSER_IS_OFFLINE) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ ver: 'v1' }, (((_7 = this.filter) === null || _7 === void 0 ? void 0 : _7.userType) && {
            userType: (_8 = this.filter) === null || _8 === void 0 ? void 0 : _8.userType
        })), (((_9 = this.filter) === null || _9 === void 0 ? void 0 : _9.schemeId) && {
            schemeId: (_10 = this.filter) === null || _10 === void 0 ? void 0 : _10.schemeId
        })), ((payload === null || payload === void 0 ? void 0 : payload.createdBy) && {
            CreatedBy: payload === null || payload === void 0 ? void 0 : payload.createdBy
        })), ((payload === null || payload === void 0 ? void 0 : payload.assessorId) && {
            AssessorId: payload === null || payload === void 0 ? void 0 : payload.assessorId
        })), ((payload === null || payload === void 0 ? void 0 : payload.siteId) && {
            SiteId: payload === null || payload === void 0 ? void 0 : payload.siteId
        })), (((_11 = this.filter) === null || _11 === void 0 ? void 0 : _11.code) && {
            code: (_12 = this.filter) === null || _12 === void 0 ? void 0 : _12.code
        })), (((_13 = this.filter) === null || _13 === void 0 ? void 0 : _13.date) && {
            StartDate: (_14 = this.filter) === null || _14 === void 0 ? void 0 : _14.date.split(',')[0],
            EndDate: (_15 = this.filter) === null || _15 === void 0 ? void 0 : _15.date.split(',')[1]
        })), { stage: ((_16 = this.filter) === null || _16 === void 0 ? void 0 : _16.stage) || '', status: ((_17 = this.filter) === null || _17 === void 0 ? void 0 : _17.status) || '', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO });
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
            this.context.commit(Mutations.SET_ASSESSMENT_LIST_PAGINATION_LOADING, true);
            ApiService.get(`${API_URLS.url}/${employeeID}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                localStorage.setItem('data-assessment-list', JSON.stringify(resData));
                this.context.commit(Mutations.SET_ASSESSMENT_LIST, resData.data);
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve(resData);
            })
                .catch((error) => {
                if (BROWSER_IS_OFFLINE) {
                    const responseString = localStorage.getItem('data-assessment-list');
                    if (typeof responseString == 'string') {
                        const responseObject = JSON.parse(responseString);
                        this.context.commit(Mutations.SET_ASSESSMENT_LIST, responseObject.data);
                        this.context.commit(Mutations.SET_ASSESSMENT_LIST_PAGINATION, {
                            currentPage: params.pageNo,
                            pageSize: params.pageSize,
                            totalItems: responseObject.totalRecords
                        });
                        resolve(responseObject);
                    }
                    else {
                        hrgsSwalAlert({
                            icon: 'error',
                            text: 'Failed get Assessment list.'
                        });
                        reject(error);
                    }
                }
                else {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: 'Failed get Assessment list.'
                    });
                    reject(error);
                }
            })
                .finally(() => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_PAGINATION_LOADING, false);
            });
        });
    }
    [_q = Actions.GET_FORM_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload.assessmentId || EMPTY_GUID}/forms/${payload.formCode}?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result.content);
                }
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Assessment Form Data.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
            });
        });
    }
    [_r = Actions.POST_FORM_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/${payload.assessmentId || EMPTY_GUID}/forms/${payload.formId}?${new URLSearchParams(params).toString()}`, payload)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.result.message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if (response.data.result.message.includes('Data was updated or deleted by another user.')) {
                                window.location.reload();
                            }
                        }
                    });
                    reject();
                }
                else {
                    const resData = response.data.result.content;
                    resolve(resData);
                }
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed create Assessment Form Data.'
                });
                reject(error);
            });
        });
    }
    [_s = Actions.UPDATE_FORM_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.assessmentId || EMPTY_GUID}/forms/${payload.formId}/${payload.id}?${new URLSearchParams(params).toString()}`, payload)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.result.message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if (response.data.result.message.includes('Data was updated or deleted by another user.')) {
                                window.location.reload();
                            }
                        }
                    });
                    reject();
                }
                else {
                    const resData = response.data.result.content;
                    resolve(resData);
                }
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed update Assessment Form Data.'
                });
                reject(error);
            });
        });
    }
    [_t = Actions.APPROVAL_FORM_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            note: payload.note,
            dataVersion: payload.dataVersion
        };
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.assessmentId}/forms/${payload.formCode}/${payload.approval}?${new URLSearchParams(params).toString()}`, formdata)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.result.message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if (response.data.result.message.includes('Data was updated or deleted by another user.')) {
                                window.location.reload();
                            }
                        }
                    });
                    reject();
                }
                else {
                    const resData = response.data.result.content;
                    resolve(resData);
                }
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed Approval Assessment Form Data.'
                });
                reject(error);
            });
        });
    }
    [_u = Actions.GET_SCHEDULE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload.assessmentId}/schedules?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Assessment schedule.'
                });
                reject(error);
            });
        });
    }
    [_v = Actions.POST_SCHEDULE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/${payload.assessmentId}/schedules?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed Create Assessment Schedule.'
                });
                reject(_response);
            });
        });
    }
    [_w = Actions.UPDATE_SCHEDULE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            formMethodId: payload === null || payload === void 0 ? void 0 : payload.formMethodId,
            testPlaceType: payload === null || payload === void 0 ? void 0 : payload.testPlaceType,
            testPlaceId: payload === null || payload === void 0 ? void 0 : payload.testPlaceId,
            meetingSchedule: payload === null || payload === void 0 ? void 0 : payload.meetingSchedule,
            meetingLink: payload === null || payload === void 0 ? void 0 : payload.meetingLink
        };
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.assessmentId}/schedules?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed Update Assessment Schedule.'
                });
                reject(_response);
            });
        });
    }
    [_x = Actions.GET_SCHEDULE_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, (this.orderBy && {
            orderBy: this.orderBy
        }));
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
            this.context.commit(Mutations.SET_ASSESSMENT_LIST_PAGINATION_LOADING, true);
            ApiService.get(`${API_URLS.url}/${employeeID}/schedules?${new URLSearchParams(Object.assign(Object.assign({}, params), this.getAssessmentNonNullFilter)).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_SCHEDULE_LIST, resData.data);
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Assessment schedule.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_PAGINATION_LOADING, false);
            });
        });
    }
    [_y = Actions.UPDATE_CERTIFICATIE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.assessmentId}/certificates?${new URLSearchParams(params).toString()}`, payload)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.result.message
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if (response.data.result.message.includes('Data was updated or deleted by another user.')) {
                                window.location.reload();
                            }
                        }
                    });
                    reject();
                }
                else {
                    const resData = response.data.result.content;
                    resolve(resData);
                }
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload certificate.'
                });
                reject(error);
            });
        });
    }
    // *EXPORT ASSESSMENT SCHEDULE LIST DATA (CREATE/CHANGE)
    [_z = Actions.EXPORT_ASSESSMENT_SCHEDULE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            gmt: payload === null || payload === void 0 ? void 0 : payload.gmt
        };
        this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/export?${new URLSearchParams(Object.assign(Object.assign({}, params), this.getAssessmentNonNullFilter)).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            });
        });
    }
    // *DOWNLOAD ASSESSMENT SCHEDULE LIST DATA
    [_0 = Actions.DOWNLOAD_ASSESSMENT_SCHEDULE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.url}/${employeeID}/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
            });
        });
    }
    // *GET DATA BINDING FORM LIST
    [_1 = Actions.GET_BINDING_FORM_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const id = payload.assessmentId;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.binding}/${employeeID}/formlist/${id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_FORM_BINDING_LIST, resData);
                resolve(resData);
            })
                .catch((error) => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get binding data'
                });
                reject(error);
            });
        });
    }
    // *VIEW DATA BINDING FORM PDF
    [_2 = Actions.VIEW_BINDING_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const id = payload.assessmentId;
        const formCode = payload.formCode;
        const gmt = payload.gmt;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.binding}/${employeeID}/generate/${id}/${formCode}/${gmt}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.result.message
                    });
                    reject();
                }
                else {
                    const resData = response.data.result.content;
                    resolve(resData);
                }
            })
                .catch((error) => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed to view data'
                });
                reject(error);
            });
        });
    }
    // *DOWNLOAD ALL DATA BINDING FORM PDF
    [_3 = Actions.DOWNLOAD_ALL_DOCUMENT](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const id = payload.assessmentId;
        const gmt = payload.gmt;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.binding}/${employeeID}/downloadall/${id}/${gmt}?${new URLSearchParams(params).toString()}`, payload.files)
                .then((response) => {
                if (response.data.result.isError) {
                    hrgsSwalAlert({
                        icon: 'error',
                        text: response.data.result.message
                    });
                    reject();
                }
                else {
                    const resData = response.data.result.content;
                    resolve(resData);
                }
            })
                .catch((error) => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed to Download All'
                });
                reject(error);
            });
        });
    }
    [_4 = Actions.GET_ASSESSMENT_ASSESOR]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
            ApiService.get(`${API_URLS.url}/${employeeID}/assessors?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result.content);
                }
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Assessment Assesor Data.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
            });
        });
    }
    [_5 = Actions.GET_ASSESSMENT_SCHEME]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, true);
            ApiService.get(`${API_URLS.url}/${employeeID}/schemes?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result.content);
                }
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get Assessment Scheme Data.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_ASSESSMENT_LIST_LOADING, false);
            });
        });
    }
    [_6 = Actions.GET_ASSESSMENT_SCHEDULE_AVAILABILITIES](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            hrgsSwalAlert({
                icon: 'error',
                text: 'Employee ID tidak ditemukan.'
            });
            return false;
        }
        const params = Object.assign(Object.assign(Object.assign({ ver: 'v1' }, ((payload === null || payload === void 0 ? void 0 : payload.assessorId) && { AssessorId: payload === null || payload === void 0 ? void 0 : payload.assessorId })), ((payload === null || payload === void 0 ? void 0 : payload.month) && { Month: payload === null || payload === void 0 ? void 0 : payload.month })), ((payload === null || payload === void 0 ? void 0 : payload.year) && { Year: payload === null || payload === void 0 ? void 0 : payload.year }));
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/schedules/availabilities?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch(() => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed Get Pre Assessment Schedule Availabilities'
                });
                reject();
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _p, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _q, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _r, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _s, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _t, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _u, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _v, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _w, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _x, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _y, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _z, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _0, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _1, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _2, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _3, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _4, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _5, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssessmentModule.prototype, _6, null);
AssessmentModule = __decorate([
    Module
], AssessmentModule);
export default AssessmentModule;
